import React from 'react'
import { Card2Style } from './PercentageCard.styled'
import { CircleStyle } from '../NavBar/NavBar.styled'

const PercentageCard = ({ heading, total,color }) => {
  return (
    <Card2Style>
        <div className='card-container'>
            <h2 className='heading'>{heading} <CircleStyle color={color} display={"inline-block"} /></h2>
            <p className='total'>{total}</p>
        </div>
    </Card2Style>
  )
}

export default PercentageCard